module.exports = __webpack_public_path__ + "img/MG_5067-1000x720.ff00e18f.jpg";